import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from 'context/AuthContext'
import { PERMISSIONS, canManageStaff, hasPermission } from 'shared/util/permissions'
import Button from 'shared/components/ui/button'
import Modal from 'shared/components/ui/Modal'

function MoreMenu() {
  const { eventId } = useParams()
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  const [logoutOpen, setLogoutOpen] = useState(false)

  const items = [
    hasPermission(user, eventId, PERMISSIONS.CREATE_ORDER) && { label: 'Gate / complimentary order', onClick: () => navigate(`/events/${eventId}/order`) },
    hasPermission(user, eventId, PERMISSIONS.EVENT_REPORT) && { label: 'Sales report', onClick: () => navigate(`/events/${eventId}/sales`) },
    canManageStaff(user) && { label: 'Manage scanner staff', onClick: () => navigate('/staff') },
    { label: 'Switch event', onClick: () => navigate('/') }
  ].filter(Boolean)

  return (
    <div className="mx-auto w-full max-w-lg px-4 py-5">
      <h2 className="mb-4 text-4xl font-bold">More</h2>
      <div className="space-y-2">
        {items.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={item.onClick}
            className="flex min-h-14 w-full items-center rounded-card bg-surface px-4 text-left font-semibold"
          >
            {item.label}
          </button>
        ))}
        <button
          type="button"
          onClick={() => setLogoutOpen(true)}
          className="flex min-h-14 w-full items-center rounded-card bg-theme-900 px-4 text-left font-semibold text-theme"
        >
          Logout
        </button>
      </div>
      <Modal open={logoutOpen} onClose={() => setLogoutOpen(false)} title="Confirm logout?">
        <p className="mb-5 text-muted">You will need OTP to sign in again.</p>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="ghost" onClick={() => setLogoutOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await logout()
              navigate('/login')
            }}
          >
            Logout
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default MoreMenu
